import { API } from "aws-amplify";

export async function setRecurringTimelapseInterval(kvsName: string, value: RecurringTimelapseConfiguration[]): Promise<void> {
  try {
    const promises = [];

    for (let i = 0; i < value.length; i += 1) {
      if (value[i].recurrence !== "none")
        promises.push(updateSchedule(kvsName, value[i], i))
      else
        promises.push(deleteSchedule(kvsName, value[i], i))
    }

    await Promise.all(promises);
  } catch (error) {
    throw error;
  }
}

async function updateSchedule(kvsName: string, value: RecurringTimelapseConfiguration, position: number): Promise<void> {
  try {
    const path: string = `/timelapse/recurring/${kvsName}/${position}`;
    await API.put(
      'api-service',
      path,
      {
        body: { ...value }
      }
    )

    return;
  } catch (error) { }

  try {
    const path: string = `/timelapse/recurring/${kvsName}`;
    await API.post(
      'api-service',
      path,
      {
        body: { ...value, position: position }
      }
    )
  } catch (error) {
    throw error;
  }
}

async function deleteSchedule(kvsName: string, value: RecurringTimelapseConfiguration, position: number): Promise<void> {
  try {
    const path: string = `/timelapse/recurring/${kvsName}/${position}`;
    await API.del(
      'api-service',
      path,
      {}
    )

    return;
  } catch (error) {
    throw error;
  }
}
